/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';

// reactstrap components
import {
  Card,
  Container,
  Row,
  Col,
  Progress, Button
} from "reactstrap";

import {RiEditFill} from "react-icons/ri";
// core components


import SongBooksDropdown from "./SongBooksDropdown";
import StatsOverviewWithSongBook from "../stats/StatsOverviewWithSongBook";
import withNavigateHook from "../../hooks/withNavigationHook";
import {useParams} from "react-router-dom";
import {getSongBookPreferences, getThemePreferences} from "../../components/helpers/UserPreferenceHelpers";
import SeoNoIndex from "../../components/helpers/SeoNoIndex";
import {SeoHelper} from "../../components/helpers/SeoHelper";

// index page sections

class ChooseSongBooks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      activeButtonActive: false
    };

    this.enableActiveButtonHandler = this.enableActiveButtonHandler.bind(this);

    // sessionStorage.removeItem("curated-songs");
    if (!sessionStorage.getItem("keepPlaylist")) {
      sessionStorage.removeItem("playlist");
    }
    if (!sessionStorage.getItem("selected-themes")) {
      sessionStorage.removeItem("selected-themes");
    }
    if (!sessionStorage.getItem("selected-passages")) {
      sessionStorage.removeItem("selected-passages");
    }

    // Prepopulate selected song books from preferred song books
    const selected = JSON.parse(sessionStorage.getItem("selected-song-books") || "[]");
    const preferred = JSON.parse(sessionStorage.getItem("preferred-song-books") || "[]");
    if (selected.length === 0 && preferred.length > 0) {
      sessionStorage.setItem("selected-song-books", JSON.stringify(preferred));
    }

    getThemePreferences().then(res => {
      sessionStorage.setItem("preferred-themes", JSON.stringify(res));
    });

    getSongBookPreferences().then(res => {
      if (!sessionStorage.getItem("preferred-song-books")) {
        const preferred = res || [];
        sessionStorage.setItem(
            "preferred-song-books",
            JSON.stringify(preferred)
        );
      }
    });
  }

  componentDidMount() {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'build_service', {
        source: 'songbooks'
      });
    }
  }

  enableActiveButtonHandler = (enable) => {
    this.setState({activeButtonActive: enable});
    // this.continueButtonAvailable();

    this.forceUpdate();
  }

  continueButtonAvailable = () => {
    const selected = sessionStorage.getItem("selected-song-books") != null && sessionStorage.getItem("selected-song-books") != 'null' ? sessionStorage.getItem("selected-song-books") : "[]";
    const preferred = sessionStorage.getItem("preferred-song-books") != null && sessionStorage.getItem("preferred-song-books") != 'null' ? sessionStorage.getItem("preferred-song-books") : "[]";
    return (JSON.parse(selected).length > 0) || (JSON.parse(preferred).length > 0);
  }

  // continueButtonAvailable = () => {
  //   sessionStorage.setItem("songBooksContinueEnabled", sessionStorage.getItem("selected-song-books") && JSON.parse(sessionStorage.getItem("selected-song-books")).length > 0);
  // }

  saveAndForwardTo = (nextPage) => {

    const selected = JSON.parse(sessionStorage.getItem("selected-song-books") || "[]");

    sessionStorage.setItem("selected-song-books", JSON.stringify(selected));

    this.props.navigation(nextPage);
  }

  render() {
    // const continueButtonEnabled = !sessionStorage.getItem("songBooksContinueEnabled") ? false : (sessionStorage.getItem("songBooksContinueEnabled") === "true");
    const continueButtonEnabled = this.continueButtonAvailable();
    let currentPage = "/";
    let nextPage = "/"; // default fallback

    if (window.location.pathname.includes("themes")) {
      currentPage = "/themes/choose-song-book";
      nextPage = "/themes/choose-themes";
    } else if (window.location.pathname.includes("scripture")) {
      currentPage = "/scripture/choose-song-book";

      if (sessionStorage.getItem("selected-passages")) {
        nextPage = "/scripture/songs";
      } else {
        nextPage = "/scripture/choose-passages";
      }
    } else if (window.location.pathname.includes("lectionary")) {
      currentPage = "/lectionary/choose-song-book";
      nextPage = "/lectionary/choose-date";
    }

    return (
      <>
        <SeoHelper
            uri={currentPage}
            title = {!sessionStorage.getItem("customer") ? "Choose a Song Book" : " Choose one or more Song Books" + " | The Worship Bible"}
            description="Find worship songs from your song books. The Worship Bible helps you create meaningful song-flows rooted in biblical themes and teachings."
        />

        {/*<main className="profile-page" ref="main">*/}
        <div className="position-relative">
          {/* shape Hero */}
          <section className="section section-lg section-shaped pb-10">
            <div className="shape shape-style-1 shape-default">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>
            <Container className="py-lg-md d-flex">
              <div className="col px-0">
                <Row>
                  <Col lg="8">
                    <h1 className="display-3 text-white">
                      Building your song-flows{" "}
                      {!sessionStorage.getItem("customer") && <>
                        <span>choose a song book</span>
                      </>}
                      {sessionStorage.getItem("customer") && <>
                        <span>choose one or more song books</span>
                      </>}
                    </h1>
                    <p className="lead text-white">
                      &nbsp;<br/>&nbsp;
                    </p>
                    {/*<div className="btn-wrapper">*/}
                    {/*  <Button*/}
                    {/*    className="btn-icon mb-3 mb-sm-0"*/}
                    {/*    color="primary"*/}
                    {/*    href="/do-you-use-a-lectionary-or-song-book"*/}
                    {/*  >*/}
                    {/*    <span className="btn-inner--icon mr-1">*/}
                    {/*      <i className="fa fa-music" />*/}
                    {/*    </span>*/}
                    {/*    <span className="btn-inner--text">Generate a Worship Playlist</span>*/}
                    {/*  </Button>*/}
                    {/*</div>*/}
                  </Col>
                </Row>
              </div>
            </Container>
            {/* SVG separator */}
            <div className="separator separator-bottom separator-skew">
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 100"
                  x="0"
                  y="0"
              >
                <polygon
                    className="fill-white"
                    points="2560 0 2560 100 0 100"
                />
              </svg>
            </div>
          </section>
          {/* 1st Hero Variation */}
        </div>
        <section className="section section-lg pt-lg-9">
          <Container>
            <Card className="card-profile shadow mt--300">
              <div className="px-4">
                <StatsOverviewWithSongBook/>
                <Row className="justify-content-center">
                  <Col md="3" xs="12">
                  </Col>
                  <Col md="6" xs="12">
                  </Col>
                  <Col md="3" xs="12">
                    <div className="text-center">
                    {(
                          (sessionStorage.getItem("curated-songs") && sessionStorage.getItem("curated-songs") != 'null' && JSON.parse(sessionStorage.getItem("curated-songs")).length > 0 && !sessionStorage.getItem("playlist")) ||
                          (sessionStorage.getItem("playlist") && sessionStorage.getItem("workingOnDraft") === "true")
                      ) && <>
                      <Button
                          className="btn-icon mb-3 mb-sm-0 mx-auto float-left"
                          color="primary"
                          href="/scripture/curated-songs"
                      >
                                <span className="btn-inner--icon mr-1">
                                  <RiEditFill title="Edit" size="16"/>
                                </span>
                          <span className="btn-inner--text">Go to song-flow</span>
                      </Button>
                    </>
                    }
                    </div>
                  </Col>
                </Row>
                <SongBooksDropdown key={new Date()} enableActiveButtonHandler={this.enableActiveButtonHandler}
                                   sessionPropName="selected-song-books" selectedTitle="Selected Song Book:"/>
                <div style={{
                  position: "fixed",
                  bottom: "0",
                  left: "0",
                  width: "100%",
                  backgroundColor: "white",
                  padding: "40px",
                  boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.2)",
                  zIndex: "1000"
                }}>
                  <div className="col-md-12 col-xs-12"
                       style={{position: "fixed", bottom: "20px", right: "0px", zIndex: "1000"}}>
                    <Button
                        type="submit"
                        id="continueButton"
                        className="btn-icon mb-3 mb-sm-0 mt-5 col-md-12 col-xs-12"
                        color="primary"
                        onClick={() => this.saveAndForwardTo(nextPage)}
                        disabled={!continueButtonEnabled}
                    >
                      <span className="btn-inner--text">Continue</span>
                    </Button>
                  </div>
                </div>
                {/*</form>*/}
                {/*<div className="mt-5 py-5 border-top text-center">*/}
                {/*  <div className="progress-wrapper">*/}
                {/*    <div className="progress-info">*/}
                {/*      <div className="progress-label">*/}
                {/*        <span>WORSHIP SONG-FLOWS CREATION TASKS COMPLETED</span>*/}
                {/*      </div>*/}
                {/*      <div className="progress-percentage">*/}
                {/*        <span>1/4</span>*/}
                {/*      </div>*/}
                {/*    </div>*/}
                {/*    <Progress max="100" value="25"/>*/}
                {/*  </div>*/}
                {/*</div>*/}
              </div>
            </Card>
          </Container>
        </section>
        {/*</main>*/}

      </>
    );
  }
}

export default withNavigateHook((props) => (
    <ChooseSongBooks{...props} params={useParams()}/>
));
